import React, { FC, useMemo, useRef } from 'react';

import { Center, Flex, Heading, Stack, Text } from '@chakra-ui/react';

import { useSKU } from 'hooks';

import {
  EditOrderModal,
  EditOrderModalRef,
} from 'components/modules/EditOrderModal';
import { UserPill } from 'components/core/UserPill';
import { DataTable } from 'components/modules/DataTable';

import { Order } from 'types/order';
import { RequestsViewProps } from './Requests.props';
import { buildRequestColumns, SkuItemsById } from './requestsColumns';

const RequestsView: FC<RequestsViewProps> = (props) => {
  const { orders, isLoading, pagination } = props;

  const editOrderModalRef = useRef<EditOrderModalRef>(null);

  const skuData = useSKU('item');
  const skuPackagesData = useSKU('package');
  const skuPackages = skuPackagesData?.data;
  const skuItems = skuData.data;

  const skuItemsById = useMemo(() => {
    const index: SkuItemsById = {};

    skuItems?.forEach((sku) => {
      index[sku._id] = sku.itemsInCase;
    });

    return index;
  }, [skuItems]);

  const columns = useMemo(
    () => buildRequestColumns(skuItemsById, skuItems || [], skuPackages || []),
    [skuItemsById, skuItems, skuPackages],
  );

  return (
    <Flex flex={1} direction="column" color="support.500" overflow="auto">
      <Flex align="flex-start" justify="space-between">
        <Heading mb={6} fontSize="24px">
          Requests
        </Heading>
        <Flex align="flex-end">
          <Stack isInline>
            <UserPill />
          </Stack>
        </Flex>
      </Flex>
      <DataTable<Order>
        minW="1300px"
        data={orders}
        columns={columns}
        isLoading={isLoading}
        pagination={pagination}
        onRowClick={(order) => {
          editOrderModalRef.current?.onOpen(order);
        }}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Requests available</Text>
          </Center>
        )}
      />
      <EditOrderModal
        ref={editOrderModalRef}
        isCustomerRequest
        renderNextOrderButton={() => null}
        renderPreviousOrderButton={() => null}
      />
    </Flex>
  );
};

export default RequestsView;
